/// <reference path="../typings/index.d.ts" />

interface IDocsEditorConfig {
    uploadUrl: string;
    uploadCapaUrl: string;
    previewUrl: string;
    artigoId: number | null;
    uploadToken: string;
    uploadMaxBytes: number;
    uploadMaxMessage: string;
    csrfToken: string;
}

interface Window {
    DocsEditorConfig?: IDocsEditorConfig;
}

namespace App.Docs {
    export class Editor {
        private config: IDocsEditorConfig;
        private area: HTMLElement;
        private input: HTMLTextAreaElement;
        private fileInput: HTMLInputElement;
        private previewPanel: HTMLElement | null;
        private previewTimer: number | null = null;
        private savedRange: Range | null = null;
        private editorRoot: HTMLElement | null = null;
        private toolbarElement: HTMLElement | null = null;
        private toolbarPlaceholder: HTMLElement | null = null;
        private toolbarFixaRaf: number | null = null;
        private toolbarFixaTop = 12;

        constructor(config: IDocsEditorConfig, area: HTMLElement, input: HTMLTextAreaElement, fileInput: HTMLInputElement) {
            this.config = config;
            this.area = area;
            this.input = input;
            this.fileInput = fileInput;
            this.previewPanel = document.getElementById('docs-preview-panel');
        }

        public inicializar(): void {
            var self = this;
            var toolbar = document.querySelector('.docs-editor__toolbar');

            if (toolbar) {
                toolbar.addEventListener('mousedown', function (event: MouseEvent) {
                    if (self.toolbarButtonFromEvent(event.target)) {
                        event.preventDefault();
                    }
                });

                toolbar.addEventListener('click', function (event: MouseEvent) {
                    var button = self.toolbarButtonFromEvent(event.target);
                    if (!button) {
                        return;
                    }

                    event.preventDefault();
                    event.stopPropagation();
                    self.restoreSelection();
                    var cmd = button.getAttribute('data-cmd');
                    var block = button.getAttribute('data-block');
                    var action = button.getAttribute('data-action');
                    var callout = button.getAttribute('data-callout');

                    if (cmd) {
                        self.exec(String(cmd));
                        return;
                    }

                    if (block) {
                        self.exec('formatBlock', '<' + block + '>');
                        return;
                    }

                    if (callout) {
                        var cls = 'docs-callout docs-callout--' + callout;
                        self.insertHtml('<div class="' + cls + '"><p>Digite o texto do destaque aqui.</p></div>');
                        return;
                    }

                    if (action === 'link') {
                        var href = window.prompt('URL do link:');
                        if (href) {
                            self.exec('createLink', href);
                        }
                        return;
                    }

                    if (action === 'table') {
                        self.insertHtml('<table class="docs-table"><thead><tr><th>Coluna 1</th><th>Coluna 2</th></tr></thead><tbody><tr><td></td><td></td></tr></tbody></table>');
                        return;
                    }

                    if (action === 'code') {
                        self.insertHtml('<pre><code>codigo aqui</code></pre>');
                        return;
                    }

                    if (action === 'image') {
                        self.abrirSeletorImagem();
                        return;
                    }

                    if (action === 'youtube') {
                        var url = window.prompt('Cole a URL do YouTube:');
                        if (url) {
                            self.insertYoutubeEmbed(url);
                        }
                    }
                });
            }

            $(this.fileInput).on('change', function () {
                var input = this as HTMLInputElement;
                if (input.files && input.files[0]) {
                    self.restoreSelection();
                    self.insertImageFromFile(input.files[0], 'botao-arquivo');
                    input.value = '';
                }
            });

            $(this.area).on('input', function () {
                self.saveSelection();
                self.syncInput();
            });

            $(this.area).on('keyup focus', function () {
                self.saveSelection();
            });
            $(this.area).on('mouseup', function (e: JQueryEventObject) {
                self.updateSelectionFromPoint(e);
                self.saveSelection();
            });

            $(this.area).on('paste', function (e: JQueryEventObject) {
                App.Docs.ImageUploadLog.info('evento-paste', { alvo: 'editor-conteudo' });
                self.onPaste(e);
            });
            $(this.area).on('keydown', function (e: JQueryEventObject) {
                self.onKeyDown(e);
            });

            $('[name="titulo"], [name="resumo"]').on('input', function () {
                self.schedulePreview();
            });

            $('#form-tutorial').on('submit', function () {
                self.syncInput();
            });

            this.normalizarMarcacoesInlineVazias();
            this.limparClassesEditor();
            this.syncInput();
            this.configurarToolbarFixa();
        }

        private configurarToolbarFixa(): void {
            var self = this;
            this.editorRoot = document.getElementById('docs-editor');
            this.toolbarElement = this.editorRoot
                ? this.editorRoot.querySelector('.docs-editor__toolbar') as HTMLElement
                : null;

            if (!this.editorRoot || !this.toolbarElement || !this.toolbarElement.parentNode) {
                return;
            }

            this.toolbarPlaceholder = document.createElement('div');
            this.toolbarPlaceholder.className = 'docs-editor__toolbar-placeholder';
            this.toolbarPlaceholder.setAttribute('aria-hidden', 'true');
            this.toolbarElement.parentNode.insertBefore(this.toolbarPlaceholder, this.toolbarElement);

            var atualizar = function () {
                self.agendarAtualizacaoToolbarFixa();
            };

            window.addEventListener('scroll', atualizar, false);
            window.addEventListener('resize', atualizar, false);
            atualizar();
        }

        private agendarAtualizacaoToolbarFixa(): void {
            var self = this;

            if (this.toolbarFixaRaf !== null) {
                return;
            }

            this.toolbarFixaRaf = window.requestAnimationFrame(function () {
                self.toolbarFixaRaf = null;
                self.atualizarToolbarFixa();
            });
        }

        private atualizarToolbarFixa(): void {
            if (!this.editorRoot || !this.toolbarElement || !this.toolbarPlaceholder) {
                return;
            }

            var editorRect = this.editorRoot.getBoundingClientRect();
            var toolbarAltura = this.toolbarElement.offsetHeight;
            var topo = this.toolbarFixaTop;
            var deveFixar = editorRect.top < topo
                && editorRect.bottom > topo + toolbarAltura + 24;

            if (deveFixar) {
                this.toolbarPlaceholder.style.display = 'block';
                this.toolbarPlaceholder.style.height = toolbarAltura + 'px';
                this.toolbarElement.classList.add('is-fixed');
                this.toolbarElement.style.top = topo + 'px';
                this.toolbarElement.style.left = editorRect.left + 'px';
                this.toolbarElement.style.width = editorRect.width + 'px';
                return;
            }

            this.toolbarPlaceholder.style.display = 'none';
            this.toolbarPlaceholder.style.height = '0';
            this.toolbarElement.classList.remove('is-fixed');
            this.toolbarElement.style.top = '';
            this.toolbarElement.style.left = '';
            this.toolbarElement.style.width = '';
        }

        private syncInput(): void {
            this.normalizeVideoBlocks();
            this.normalizeRootTextNodes();
            this.normalizeSimpleRootDivs();
            this.normalizarMarcacoesInlineVazias();
            this.limparClassesEditor();
            this.input.value = this.area.innerHTML;
            this.schedulePreview();
        }

        private limparClassesEditor(): void {
            var classesRemover = ['isSelectedEnd', 'isSelected', 'Apple-interchange-newline'];
            var elementos = this.area.querySelectorAll('[class]');
            var i: number;
            var j: number;

            for (i = 0; i < elementos.length; i++) {
                var elemento = elementos[i] as HTMLElement;
                var classes = (elemento.getAttribute('class') || '').split(/\s+/);
                var filtradas: string[] = [];

                for (j = 0; j < classes.length; j++) {
                    if (classes[j] !== '' && classesRemover.indexOf(classes[j]) === -1) {
                        filtradas.push(classes[j]);
                    }
                }

                if (filtradas.length === 0) {
                    elemento.removeAttribute('class');
                } else {
                    elemento.setAttribute('class', filtradas.join(' '));
                }
            }
        }

        private normalizarMarcacoesInlineVazias(): void {
            var tags = ['strong', 'b', 'em', 'i', 'u'];
            var t: number;

            for (t = 0; t < tags.length; t++) {
                var nos = this.area.querySelectorAll(tags[t]);
                var i: number;

                for (i = nos.length - 1; i >= 0; i--) {
                    var no = nos[i] as HTMLElement;
                    var texto = (no.textContent || '').replace(/\u00a0/g, ' ').trim();

                    if (texto === '' && no.parentNode) {
                        no.parentNode.removeChild(no);
                    }
                }
            }
        }

        private schedulePreview(): void {
            if (this.previewTimer !== null) {
                clearTimeout(this.previewTimer);
            }
            this.previewTimer = window.setTimeout(() => this.updatePreview(), 300);
        }

        private updatePreview(): void {
            if (!this.previewPanel) {
                return;
            }

            var body = this.previewPanel.querySelector('#docs-article-body') || this.previewPanel.querySelector('.docs-article-body');
            if (body) {
                body.innerHTML = this.area.innerHTML;
            }

            var titulo = document.querySelector('[name="titulo"]') as HTMLInputElement;
            var resumo = document.querySelector('[name="resumo"]') as HTMLTextAreaElement;
            var h1 = this.previewPanel.querySelector('h1');
            var resumoEl = this.previewPanel.querySelector('.docs-page-header p');

            if (h1 && titulo) {
                h1.textContent = titulo.value || 'Título do tutorial';
            }
            if (resumoEl && resumo) {
                resumoEl.textContent = resumo.value || '';
            }
        }

        private exec(cmd: string, value?: string): void {
            this.restoreSelection();
            document.execCommand(cmd, false, value || null);
            this.syncInput();
        }

        private toolbarButtonFromEvent(target: EventTarget): HTMLButtonElement | null {
            var node = target as HTMLElement | null;
            while (node && node !== document.body) {
                if (node.tagName && node.tagName.toLowerCase() === 'button') {
                    return node as HTMLButtonElement;
                }
                if (node.className && String(node.className).indexOf('docs-editor__toolbar') !== -1) {
                    return null;
                }
                node = node.parentNode as HTMLElement | null;
            }

            return null;
        }

        private insertHtml(html: string): void {
            this.restoreSelection();
            document.execCommand('insertHTML', false, html);
            this.syncInput();
            this.saveSelection();
        }

        private selectionIsInsideEditor(range: Range): boolean {
            var container = range.commonAncestorContainer;
            var node = container.nodeType === 1 ? container as HTMLElement : container.parentNode;

            while (node) {
                if (node === this.area) {
                    return true;
                }
                node = node.parentNode;
            }

            return false;
        }

        private saveSelection(): void {
            var selection = window.getSelection ? window.getSelection() : null;
            if (!selection || selection.rangeCount === 0) {
                return;
            }

            var range = selection.getRangeAt(0);
            if (this.selectionIsInsideEditor(range)) {
                this.savedRange = range.cloneRange();
            }
        }

        private restoreSelection(): void {
            this.area.focus();

            var selection = window.getSelection ? window.getSelection() : null;
            if (!selection) {
                return;
            }

            selection.removeAllRanges();
            if (this.savedRange) {
                selection.addRange(this.savedRange);
                return;
            }

            var range = document.createRange();
            range.selectNodeContents(this.area);
            range.collapse(false);
            selection.addRange(range);
        }

        private updateSelectionFromPoint(e: JQueryEventObject): void {
            var original = e.originalEvent as MouseEvent;
            if (!original || typeof original.clientX !== 'number' || typeof original.clientY !== 'number') {
                return;
            }

            var selection = window.getSelection ? window.getSelection() : null;
            if (!selection || (selection.toString && selection.toString() !== '')) {
                return;
            }

            var range: Range | null = null;
            var doc = document as any;
            if (doc.caretRangeFromPoint) {
                range = doc.caretRangeFromPoint(original.clientX, original.clientY);
            } else if (doc.caretPositionFromPoint) {
                var position = doc.caretPositionFromPoint(original.clientX, original.clientY);
                if (position) {
                    range = document.createRange();
                    range.setStart(position.offsetNode, position.offset);
                    range.collapse(true);
                }
            }

            if (!range || !this.selectionIsInsideEditor(range)) {
                return;
            }

            selection.removeAllRanges();
            selection.addRange(range);
        }

        private escapeAttr(value: string): string {
            return String(value || '')
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        }

        private escapeHtml(value: string): string {
            return String(value || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        }

        private plainTextToHtml(text: string): string {
            var normalized = String(text || '').replace(/\r\n?/g, '\n');
            var lines = normalized.split('\n');
            var html = '';

            for (var i = 0; i < lines.length; i++) {
                html += lines[i] === ''
                    ? '<p><br></p>'
                    : '<p>' + this.escapeHtml(lines[i]) + '</p>';
            }

            return html;
        }

        private closestElement(node: Node | null): HTMLElement | null {
            if (!node) {
                return null;
            }

            if (node.nodeType === 1) {
                return node as HTMLElement;
            }

            return node.parentNode as HTMLElement | null;
        }

        private closestVideo(node: Node | null): HTMLElement | null {
            var element = this.closestElement(node);
            while (element && element !== this.area) {
                if (element.className && String(element.className).indexOf('docs-video') !== -1) {
                    return element;
                }
                element = element.parentNode as HTMLElement | null;
            }

            return null;
        }

        private setCaretAtStart(element: HTMLElement): void {
            var selection = window.getSelection ? window.getSelection() : null;
            if (!selection) {
                return;
            }

            var range = document.createRange();
            range.selectNodeContents(element);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
            this.savedRange = range.cloneRange();
        }

        private textOutsideVideo(element: HTMLElement): string {
            var clone = element.cloneNode(true) as HTMLElement;
            var videos = clone.querySelectorAll('.docs-video');
            var i: number;

            for (i = 0; i < videos.length; i++) {
                if (videos[i].parentNode) {
                    videos[i].parentNode.removeChild(videos[i]);
                }
            }

            var iframes = clone.querySelectorAll('iframe');
            for (i = 0; i < iframes.length; i++) {
                if (iframes[i].parentNode) {
                    iframes[i].parentNode.removeChild(iframes[i]);
                }
            }

            return (clone.textContent || '').replace(/\s+/g, ' ').trim();
        }

        private ensureTrailingEditableBlock(): HTMLElement {
            var last = this.area.lastChild as HTMLElement | null;
            if (last && last.nodeType === 1 && last.className && String(last.className).indexOf('docs-video') !== -1) {
                var block = document.createElement('p');
                block.innerHTML = '<br>';
                this.area.appendChild(block);
                return block;
            }

            if (last && last.nodeType === 1) {
                return last as HTMLElement;
            }

            var fallback = document.createElement('p');
            fallback.innerHTML = '<br>';
            this.area.appendChild(fallback);
            return fallback;
        }

        private normalizeVideoBlocks(): void {
            var videos = this.area.querySelectorAll('.docs-video');
            var changed = false;

            for (var i = videos.length - 1; i >= 0; i--) {
                var video = videos[i] as HTMLElement;
                if (!video.parentNode) {
                    continue;
                }

                var iframe = video.querySelector('iframe');
                var text = this.textOutsideVideo(video);
                var nestedVideo = video.querySelector('.docs-video');
                var isCanonical = iframe
                    && !nestedVideo
                    && text === ''
                    && video.getAttribute('contenteditable') === 'false'
                    && video.children.length === 1
                    && video.children[0].tagName.toLowerCase() === 'iframe';

                if (isCanonical) {
                    continue;
                }

                if (!iframe) {
                    if (text !== '') {
                        var textBlock = document.createElement('p');
                        textBlock.textContent = text;
                        video.parentNode.replaceChild(textBlock, video);
                    } else {
                        video.parentNode.removeChild(video);
                    }
                    changed = true;
                    continue;
                }

                var canonical = document.createElement('div');
                canonical.className = 'docs-video';
                canonical.setAttribute('contenteditable', 'false');
                canonical.appendChild(iframe.cloneNode(true));

                var fragment = document.createDocumentFragment();
                if (text !== '') {
                    var before = document.createElement('p');
                    before.textContent = text;
                    fragment.appendChild(before);
                }
                fragment.appendChild(canonical);

                video.parentNode.replaceChild(fragment, video);
                changed = true;
            }

            if (changed) {
                this.ensureTrailingEditableBlock();
            }
        }

        private normalizeRootTextNodes(): void {
            var selection = window.getSelection ? window.getSelection() : null;
            var range = selection && selection.rangeCount ? selection.getRangeAt(0).cloneRange() : null;
            var changed = false;
            var children: Node[] = [];

            for (var i = 0; i < this.area.childNodes.length; i++) {
                children.push(this.area.childNodes[i]);
            }

            for (i = 0; i < children.length; i++) {
                var node = children[i];
                if (node.nodeType !== 3) {
                    continue;
                }

                var text = node.textContent || '';
                if (text.replace(/\u00a0/g, ' ').trim() === '') {
                    if (node.parentNode) {
                        node.parentNode.removeChild(node);
                        changed = true;
                    }
                    continue;
                }

                var wrapper = document.createElement('p');
                wrapper.textContent = text;
                if (node.parentNode) {
                    node.parentNode.replaceChild(wrapper, node);
                    changed = true;

                    if (range && wrapper.firstChild) {
                        if (range.startContainer === node) {
                            range.setStart(wrapper.firstChild, Math.min(range.startOffset, text.length));
                        }
                        if (range.endContainer === node) {
                            range.setEnd(wrapper.firstChild, Math.min(range.endOffset, text.length));
                        }
                    }
                }
            }

            if (changed && selection && range && this.selectionIsInsideEditor(range)) {
                selection.removeAllRanges();
                selection.addRange(range);
                this.savedRange = range.cloneRange();
            }
        }

        private normalizeSimpleRootDivs(): void {
            var children: Node[] = [];
            for (var i = 0; i < this.area.childNodes.length; i++) {
                children.push(this.area.childNodes[i]);
            }

            for (i = 0; i < children.length; i++) {
                var node = children[i] as HTMLElement;
                if (!node || node.nodeType !== 1 || node.tagName.toLowerCase() !== 'div') {
                    continue;
                }

                if (node.className || node.getAttribute('style') || node.querySelector('div, table, ul, ol, blockquote, pre, iframe, img')) {
                    continue;
                }

                var paragraph = document.createElement('p');
                while (node.firstChild) {
                    paragraph.appendChild(node.firstChild);
                }
                if (!paragraph.childNodes.length) {
                    paragraph.innerHTML = '<br>';
                }
                node.parentNode.replaceChild(paragraph, node);
            }
        }

        private closestEditableBlock(node: Node | null): HTMLElement | null {
            var element = this.closestElement(node);
            while (element && element !== this.area) {
                var tag = element.tagName ? element.tagName.toLowerCase() : '';
                if (tag === 'p' || tag === 'div' || tag === 'h1' || tag === 'h2' || tag === 'h3' || tag === 'h4' || tag === 'h5' || tag === 'h6' || tag === 'li' || tag === 'blockquote') {
                    return element;
                }
                element = element.parentNode as HTMLElement | null;
            }

            return null;
        }

        private fragmentHasContent(fragment: DocumentFragment): boolean {
            var wrapper = document.createElement('div');
            wrapper.appendChild(fragment.cloneNode(true));
            if ((wrapper.textContent || '').replace(/\u00a0/g, ' ').trim() !== '') {
                return true;
            }

            return !!wrapper.querySelector('img, iframe, table, ul, ol, blockquote, pre, hr');
        }

        private ensureEditableContent(element: HTMLElement): void {
            if (!element.childNodes.length || (element.textContent || '').replace(/\u00a0/g, ' ').trim() === '') {
                element.innerHTML = '<br>';
            }
        }

        private insertParagraphBreak(selection: Selection): void {
            if (!selection.rangeCount) {
                return;
            }

            var range = selection.getRangeAt(0);
            if (!range.collapsed) {
                range.deleteContents();
            }

            var currentBlock = this.closestEditableBlock(range.startContainer) || this.ensureTrailingEditableBlock();
            if (!currentBlock || !currentBlock.parentNode) {
                return;
            }

            var newBlock = document.createElement('p');
            var tailRange = range.cloneRange();
            try {
                tailRange.setEnd(currentBlock, currentBlock.childNodes.length);
                var tail = tailRange.extractContents();
                if (this.fragmentHasContent(tail)) {
                    newBlock.appendChild(tail);
                } else {
                    newBlock.innerHTML = '<br>';
                }
            } catch (err) {
                newBlock.innerHTML = '<br>';
            }

            this.ensureEditableContent(currentBlock);
            currentBlock.parentNode.insertBefore(newBlock, currentBlock.nextSibling);
            this.setCaretAtStart(newBlock);
            this.syncInput();
        }

        private removableVideoFromSelection(selection: Selection, key: string): HTMLElement | null {
            if (selection.rangeCount === 0) {
                return null;
            }

            var range = selection.getRangeAt(0);
            var selectedVideo = this.closestVideo(range.commonAncestorContainer)
                || this.closestVideo(range.startContainer)
                || this.closestVideo(range.endContainer);
            if (selectedVideo) {
                return selectedVideo;
            }

            if (!range.collapsed) {
                var fragment = range.cloneContents();
                var selected = fragment.querySelector ? fragment.querySelector('.docs-video') : null;
                if (selected) {
                    var videos = this.area.querySelectorAll('.docs-video');
                    for (var i = 0; i < videos.length; i++) {
                        if ((videos[i] as HTMLElement).outerHTML === (selected as HTMLElement).outerHTML) {
                            return videos[i] as HTMLElement;
                        }
                    }
                }
                return null;
            }

            var container = range.startContainer;
            var offset = range.startOffset;
            var element = this.closestElement(container);
            if (!element) {
                return null;
            }

            var node: Node | null = null;
            if (container.nodeType === 1) {
                node = key === 'Backspace'
                    ? container.childNodes[offset - 1]
                    : container.childNodes[offset];
            } else if (key === 'Backspace' && offset === 0) {
                node = element.previousSibling;
            } else if (key === 'Delete' && offset === (container.textContent || '').length) {
                node = element.nextSibling;
            }

            return this.closestVideo(node);
        }

        private onKeyDown(e: JQueryEventObject): void {
            var original = e.originalEvent as KeyboardEvent;
            var key = original ? original.key : '';
            if (key !== 'Backspace' && key !== 'Delete' && key !== 'Enter') {
                return;
            }

            var selection = window.getSelection ? window.getSelection() : null;
            if (!selection) {
                return;
            }

            if (key === 'Enter') {
                var currentVideo = selection.rangeCount ? this.closestVideo(selection.getRangeAt(0).commonAncestorContainer) : null;
                if (currentVideo && currentVideo.parentNode) {
                    e.preventDefault();
                    var block = document.createElement('p');
                    block.innerHTML = '<br>';
                    currentVideo.parentNode.insertBefore(block, currentVideo.nextSibling);
                    this.setCaretAtStart(block);
                    this.syncInput();
                } else {
                    e.preventDefault();
                    this.insertParagraphBreak(selection);
                }
                return;
            }

            var video = this.removableVideoFromSelection(selection, key);
            if (!video || !video.parentNode) {
                return;
            }

            e.preventDefault();
            video.parentNode.removeChild(video);
            this.syncInput();
            this.saveSelection();
        }

        private insertUploadPlaceholder(): string {
            var id = 'docs-upload-' + Date.now() + '-' + Math.floor(Math.random() * 1000);
            this.insertHtml(
                '<span id="' + id + '" data-docs-upload-placeholder="' + id + '" class="docs-upload-placeholder">'
                + '<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>'
                + 'Enviando imagem... <span class="docs-upload-progress">0%</span>'
                + '</span>'
            );
            return id;
        }

        private atualizarProgressoUpload(placeholderId: string, percentual: number): void {
            var placeholder = document.getElementById(placeholderId);
            if (!placeholder) {
                return;
            }

            var progressEl = placeholder.querySelector('.docs-upload-progress');
            if (progressEl) {
                progressEl.textContent = percentual + '%';
            }
        }

        private removePlaceholder(placeholderId: string): void {
            var placeholder = document.getElementById(placeholderId);
            if (placeholder && placeholder.parentNode) {
                placeholder.parentNode.removeChild(placeholder);
                this.syncInput();
            }
        }

        private replacePlaceholder(placeholderId: string, html: string): void {
            var placeholder = document.getElementById(placeholderId);
            if (placeholder && placeholder.parentNode) {
                placeholder.outerHTML = html;
                this.syncInput();
                return;
            }

            var orphan = this.area.querySelector('[data-docs-upload-placeholder="' + placeholderId + '"]');
            if (orphan && orphan.parentNode) {
                orphan.outerHTML = html;
                this.syncInput();
                return;
            }

            this.removeUploadTextFallback();
            this.insertHtml(html);
        }

        private removeUploadTextFallback(): void {
            var nodes = this.area.querySelectorAll('p, span, div');
            for (var i = 0; i < nodes.length; i++) {
                if ((nodes[i].textContent || '').trim() === 'Enviando imagem...') {
                    if (nodes[i].parentNode) {
                        nodes[i].parentNode.removeChild(nodes[i]);
                    }
                }
            }
        }

        private handleUploadFailure(placeholderId: string, xhr: JQueryXHR): void {
            var msg = 'Falha ao enviar imagem.';
            var response = xhr.responseJSON as { mensagem?: string; errors?: { [key: string]: string[] }; docs_img_upload_log?: any[] };

            if (response && response.mensagem) {
                msg = response.mensagem;
            } else if (response && response.errors) {
                $.each(response.errors, function (_, errors) {
                    if (errors && errors.length) {
                        msg = errors[0];
                        return false;
                    }
                });
            }

            App.Docs.ImageUploadLog.error('upload-falhou', {
                status: xhr.status,
                mensagem: msg,
                responseText: xhr.responseText,
            });

            if (response && response.docs_img_upload_log) {
                App.Docs.ImageUploadLog.servidor(response.docs_img_upload_log);
            }

            this.removePlaceholder(placeholderId);
            this.removeUploadTextFallback();
            this.syncInput();
            App.Docs.AdminUx.notificarErro(msg);
        }

        private abrirSeletorImagem(): void {
            var input = this.fileInput;
            if (!input) {
                return;
            }

            input.value = '';

            if (typeof (input as any).showPicker === 'function') {
                try {
                    (input as any).showPicker();
                    return;
                } catch (err) {
                    // Fallback abaixo para navegadores que bloqueiam showPicker.
                }
            }

            input.click();
        }

        private uploadImage(file: File, placeholderId: string, origem: string): JQueryXHR {
            var self = this;
            var formData = new FormData();
            formData.append('arquivo', file);
            formData.append('_token', this.config.csrfToken);
            if (this.config.artigoId) {
                formData.append('artigo_id', String(this.config.artigoId));
            }
            if (this.config.uploadToken) {
                formData.append('upload_token', this.config.uploadToken);
            }

            var slugInput = document.querySelector('[name="slug"]') as HTMLInputElement | null;
            var slug = slugInput && slugInput.value.trim() !== '' ? slugInput.value.trim() : '';
            if (slug !== '') {
                formData.append('slug', slug);
            }

            var categoriaSlug = App.Docs.AdminUx.obterCategoriaSlugSelecionada();

            if (categoriaSlug) {
                formData.append('categoria_slug', categoriaSlug);
            }

            App.Docs.ImageUploadLog.info('upload-iniciado', {
                origem: origem,
                placeholder_id: placeholderId,
                url: this.config.uploadUrl,
                artigo_id: this.config.artigoId,
                upload_token: this.config.uploadToken,
                slug: slug,
                categoria_slug: categoriaSlug,
            });

            return $.ajax({
                url: this.config.uploadUrl,
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                xhr: function () {
                    var xhr = $.ajaxSettings.xhr();
                    if (xhr.upload) {
                        xhr.upload.addEventListener('progress', function (event: ProgressEvent) {
                            if (event.lengthComputable) {
                                var pct = Math.round((event.loaded / event.total) * 100);
                                self.atualizarProgressoUpload(placeholderId, pct);
                            }
                        }, false);
                    }
                    return xhr;
                },
            });
        }

        private insertImageFromFile(file: File, origem: string): void {
            var self = this;

            App.Docs.ImageUploadLog.dadosArquivo(file, origem);

            if (!App.Docs.AdminUx.validarTamanhoImagem(file, this.config)) {
                App.Docs.ImageUploadLog.warn('arquivo-rejeitado-tamanho', { origem: origem });
                return;
            }

            var placeholderId = this.insertUploadPlaceholder();
            App.Docs.ImageUploadLog.info('placeholder-inserido', { origem: origem, placeholder_id: placeholderId });

            this.uploadImage(file, placeholderId, origem).done(function (response: { sucesso?: boolean; url?: string; mensagem?: string; docs_img_upload_log?: any[] }) {
                App.Docs.ImageUploadLog.info('upload-resposta-recebida', {
                    origem: origem,
                    sucesso: !!(response && response.sucesso),
                    url: response && response.url ? response.url : null,
                    mensagem: response && response.mensagem ? response.mensagem : null,
                });

                if (response && response.docs_img_upload_log) {
                    App.Docs.ImageUploadLog.servidor(response.docs_img_upload_log);
                }

                if (response && response.sucesso && response.url) {
                    self.replacePlaceholder(placeholderId, '<img src="' + self.escapeAttr(response.url) + '" alt="" loading="lazy">');
                    App.Docs.ImageUploadLog.verificarUrlImagem(response.url, origem + '-apos-inserir');
                    App.Docs.AdminUx.notificarSucesso('Imagem enviada com sucesso.');
                } else {
                    self.removePlaceholder(placeholderId);
                    self.removeUploadTextFallback();
                    self.syncInput();
                    App.Docs.AdminUx.notificarErro((response && response.mensagem) || 'Falha ao enviar imagem.');
                }
            }).fail(function (xhr: JQueryXHR) {
                self.handleUploadFailure(placeholderId, xhr);
            });
        }

        private parseYoutubeId(url: string): string | null {
            var patterns = [
                /youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/,
                /youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/,
                /youtu\.be\/([a-zA-Z0-9_-]{11})/,
                /youtube-nocookie\.com\/embed\/([a-zA-Z0-9_-]{11})/,
            ];

            for (var i = 0; i < patterns.length; i++) {
                var match = url.match(patterns[i]);
                if (match) {
                    return match[1];
                }
            }

            return null;
        }

        private insertYoutubeEmbed(url: string): void {
            var id = this.parseYoutubeId(url);
            if (!id) {
                App.Docs.AdminUx.notificarErro('URL do YouTube inválida.');
                return;
            }

            var src = 'https://www.youtube-nocookie.com/embed/' + id;
            var html = '<div class="docs-video" contenteditable="false"><iframe src="' + src + '" title="Vídeo YouTube" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen loading="lazy"></iframe></div><div><br></div>';
            this.insertHtml(html);
        }

        private tagsHtmlPermitidasColagem: { [key: string]: boolean } = {
            p: true, h1: true, h2: true, h3: true, h4: true, h5: true, h6: true,
            ul: true, ol: true, li: true, a: true, strong: true, b: true, em: true, i: true, u: true, br: true,
            img: true, table: true, thead: true, tbody: true, tr: true, th: true, td: true,
            pre: true, code: true, blockquote: true, div: true, span: true, hr: true,
        };

        private atributosHtmlPermitidosColagem: { [tag: string]: { [attr: string]: boolean } } = {
            a: { href: true, title: true, target: true, rel: true },
            img: { src: true, alt: true, title: true, width: true, height: true, loading: true, class: true },
            div: { class: true, style: true },
            span: { class: true, style: true },
            p: { class: true },
            h1: { class: true, id: true },
            h2: { class: true, id: true },
            h3: { class: true, id: true },
            h4: { class: true, id: true },
            pre: { class: true },
            code: { class: true },
            table: { class: true },
            th: { colspan: true, rowspan: true },
            td: { colspan: true, rowspan: true },
        };

        private sanitizarHtmlColado(html: string): string {
            var doc = document.implementation.createHTMLDocument('');
            var container = doc.createElement('div');
            container.innerHTML = html;
            this.limparNoHtmlColado(container);
            return container.innerHTML;
        }

        private limparNoHtmlColado(no: Node): void {
            var filhos: Node[] = [];
            var i: number;

            for (i = 0; i < no.childNodes.length; i++) {
                filhos.push(no.childNodes[i]);
            }

            for (i = 0; i < filhos.length; i++) {
                var filho = filhos[i];

                if (filho.nodeType === Node.COMMENT_NODE) {
                    if (filho.parentNode) {
                        filho.parentNode.removeChild(filho);
                    }
                    continue;
                }

                if (filho.nodeType !== Node.ELEMENT_NODE) {
                    continue;
                }

                var elemento = filho as HTMLElement;
                var tag = elemento.tagName ? elemento.tagName.toLowerCase() : '';

                if (!this.tagsHtmlPermitidasColagem[tag]) {
                    this.desembrulharNoHtmlColado(elemento);
                    this.limparNoHtmlColado(elemento.parentNode || elemento);
                    continue;
                }

                if (tag === 'img' && !this.imagemColadaPermitida(elemento.getAttribute('src') || '')) {
                    if (elemento.parentNode) {
                        elemento.parentNode.removeChild(elemento);
                    }
                    continue;
                }

                if (tag === 'a') {
                    var href = elemento.getAttribute('href') || '';
                    if (href === '' || /^\s*javascript:/i.test(href)) {
                        elemento.removeAttribute('href');
                    } else {
                        elemento.setAttribute('rel', 'noopener noreferrer');
                        if (href.indexOf('http') === 0) {
                            elemento.setAttribute('target', '_blank');
                        }
                    }
                }

                this.limparAtributosHtmlColado(elemento, tag);
                this.limparNoHtmlColado(elemento);
            }
        }

        private limparAtributosHtmlColado(elemento: HTMLElement, tag: string): void {
            var permitidos = this.atributosHtmlPermitidosColagem[tag] || {};
            var remover: string[] = [];
            var j: number;

            for (j = 0; j < elemento.attributes.length; j++) {
                var atributo = elemento.attributes[j];
                var nome = atributo.name ? atributo.name.toLowerCase() : '';

                if (nome.indexOf('on') === 0 || !permitidos[nome]) {
                    remover.push(nome);
                }
            }

            for (j = 0; j < remover.length; j++) {
                elemento.removeAttribute(remover[j]);
            }

            if (elemento.hasAttribute('style')) {
                var style = elemento.getAttribute('style') || '';
                if (/expression|javascript|url\s*\(/i.test(style)) {
                    elemento.removeAttribute('style');
                }
            }
        }

        private imagemColadaPermitida(src: string): boolean {
            src = (src || '').trim();
            if (src === '' || /^\s*javascript:/i.test(src)) {
                return false;
            }

            return /^(\/)?uploads\/(?:_tmp\/[a-zA-Z0-9_-]+|[a-z0-9-]+(?:\/[a-z0-9-]+)?)\/[a-zA-Z0-9_.-]+$/i.test(src)
                || /^(\/)?uploads\/categorias\/[a-z0-9-]+\//i.test(src)
                || /^(\/)?uploads\/docs\//i.test(src);
        }

        private desembrulharNoHtmlColado(elemento: HTMLElement): void {
            var pai = elemento.parentNode;
            if (!pai) {
                return;
            }

            while (elemento.firstChild) {
                pai.insertBefore(elemento.firstChild, elemento);
            }

            pai.removeChild(elemento);
        }

        private onPaste(e: JQueryEventObject): void {
            var original = e.originalEvent as ClipboardEvent;
            var clipboard = original.clipboardData;
            if (!clipboard) {
                return;
            }

            var itemList = clipboard.items;
            var i: number;
            if (itemList) {
                for (i = 0; i < itemList.length; i++) {
                    if (itemList[i].type && itemList[i].type.indexOf('image') !== -1) {
                        e.preventDefault();
                        var fileFromItem = itemList[i].getAsFile();
                        App.Docs.ImageUploadLog.info('paste-imagem-detectada', {
                            tipo_clipboard: itemList[i].type,
                            arquivo_obtido: !!fileFromItem,
                        });
                        if (fileFromItem) {
                            this.insertImageFromFile(fileFromItem, 'ctrl-v-clipboard-items');
                        }
                        return;
                    }
                }
            }

            var fileList = clipboard.files;
            if (fileList) {
                for (i = 0; i < fileList.length; i++) {
                    if (fileList[i].type && fileList[i].type.indexOf('image') !== -1) {
                        e.preventDefault();
                        App.Docs.ImageUploadLog.info('paste-imagem-detectada', {
                            tipo_clipboard: fileList[i].type,
                            origem: 'clipboard-files',
                        });
                        this.insertImageFromFile(fileList[i], 'ctrl-v-clipboard-files');
                        return;
                    }
                }
            }

            var htmlColado = clipboard.getData ? clipboard.getData('text/html') : '';
            if (htmlColado && htmlColado.replace(/\s/g, '') !== '') {
                e.preventDefault();
                var htmlLimpo = this.sanitizarHtmlColado(htmlColado);
                if (htmlLimpo.replace(/\s/g, '') !== '') {
                    this.insertHtml(htmlLimpo);
                    return;
                }
            }

            var text = clipboard.getData ? clipboard.getData('text/plain') : '';
            if (text) {
                e.preventDefault();
                this.insertHtml(this.plainTextToHtml(text));
            }
        }
    }

    export class EditorBootstrap {
        private static instancia: Editor | null = null;

        public static inicializar(): void {
            var area = document.getElementById('docs-editor-area');
            var input = document.getElementById('docs-editor-input') as HTMLTextAreaElement;
            var fileInput = document.getElementById('docs-editor-file') as HTMLInputElement;
            var config = window.DocsEditorConfig;

            if (!area || !input || !fileInput || !config) {
                return;
            }

            if (EditorBootstrap.instancia) {
                return;
            }

            EditorBootstrap.instancia = new Editor(config, area, input, fileInput);
            EditorBootstrap.instancia.inicializar();
        }
    }
}

(window as any).App = App;

$(document).ready(function () {
    if (typeof App !== 'undefined' && App.Docs && App.Docs.EditorBootstrap) {
        App.Docs.EditorBootstrap.inicializar();
    }
});
